import React from 'react';
import ScrollingSection from '../../../../../components/scrolling-section';
import { generateCategoryRoute } from '../../../../../helpers';
import { includedWorkoutsTitle } from '../../../../../i18n/translations';
import SignUpAccess from '../../../../../components/sign-up-access';
import { FREE_CATEGORY_TITLE } from '../../../../../helpers/merge-slugs';
import { useEntitiesRowQuery } from '../../../../../client/query/entities';
import { useConfig } from '../../../../../store/reducers/config';

interface IProps {
  title: string;
  href: string;
  index: number;
}

export const defaultRoute = generateCategoryRoute(FREE_CATEGORY_TITLE);
export const IncludedWorkoutsRow: React.FC<IProps> = (props: IProps) => {
  const { title, href, index } = props;
  const { isEmbedded } = useConfig();

  const { isError, isFetching, data, refetch } = useEntitiesRowQuery({
    includedEntities: ['workout'],
    freeOnly: true,
  });
  const content = data ? data[0] : { data: [], hasMoreItems: false };

  const route = href || defaultRoute;

  return (
    <div>
      {isEmbedded && (
        <ScrollingSection
          reload={refetch}
          isLoading={isFetching}
          title={title || includedWorkoutsTitle()}
          listData={content}
          route={route}
          isError={isError}
          analytics={{
            engagementData: {
              rowNumber: index,
            },
          }}
        />
      )}
      <SignUpAccess key={'signUpAccessSection'} />
    </div>
  );
};

export default IncludedWorkoutsRow;
